// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608140938/js/" + chunkId + "." + {"44":"c7d42f25","225":"9e2fd36b","481":"1a082242","486":"6643c38f","770":"ea76c9a3"}[chunkId] + ".0.04794905836387142.chunk.js";
};